/*
 * @overview: SDK入口
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-03-10 16:42:48
 */

import { initOptions, setUp, tracker } from "../core";
import { accessTracker_Manual } from "../lib";
function init(Vue, options = {}) {
  if (!options.projectName) {
    return console.error(`webcrawling 缺少必须配置项：projectName`);
  }
  // 初始化配置
  initOptions(options).then(() => {
    setUp(Vue);
  });
}

// vue项目入口
const install = function (Vue, options = {}) {
  init(Vue, options);
};

export default {
  init,
  install,
  tracker,
  accessTracker_Manual,
};
